module.exports = __webpack_public_path__ + "static/img/500.a4d4189.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/500.png
// module id = JE9E
// module chunks = 1